<section
  class="zag-accordion-item"
  [class.zag-accordion-item--expanded]="expanded()"
  [class.zag-accordion-item--disabled]="disabled()"
  [class.zag-accordion-item--flat]="flat()"
  [class.zag-accordion-item--collection-header]="headerVariant() === 'collection'"
  [zagScrollIntoView]="!disableAutoScroll()"
  [scrollOnSignal]="expanded"
  [scrollEvents]="[]"
  [scrollDelay]="100"
  scrollBlock="start"
>
  @if (!flat()) {
  <div
    class="zag-accordion-item__toggle"
    role="button"
    [attr.tabindex]="disabled() ? -1 : 0"
    (click)="toggle($event)"
    (keydown.enter)="handleToggleKey($event)"
    (keydown.space)="handleToggleKey($event)"
    [attr.aria-expanded]="expanded()"
    [attr.aria-controls]="expanded() ? contentId : null"
    [attr.aria-disabled]="disabled() ? true : null"
  >
    <span class="zag-accordion-item__icon zag-accordion-item__icon--slot">
      <ng-content select="[slot=icon]" />
    </span>
    @if (icon()) {
    <span [zagIcon]="icon()!" class="zag-accordion-item__icon zag-accordion-item__icon--material"></span>
    }
    <span class="zag-accordion-item__title">{{ title() }}</span>
    @if (badge() !== null) {
    <span class="zag-accordion-item__badge">{{ badge() }}</span>
    } @if (statusIcon()) {
    <span
      [zagIcon]="statusIcon()!"
      class="zag-accordion-item__status-icon"
      [class.zag-accordion-item__status-icon--warning]="statusVariant() === 'warning'"
    ></span>
    }
    <span class="zag-accordion-item__actions">
      <ng-content select="[slot=actions]" />
    </span>
    <span zagIcon="expand_more" class="zag-accordion-item__chevron" [class.zag-accordion-item__chevron--expanded]="expanded()"></span>
  </div>
  } @if (expanded() || flat()) {
  <div [id]="contentId" class="zag-accordion-item__content">
    <ng-content />
  </div>
  }
</section>
